module.exports = __webpack_public_path__ + "static/logo2-b2e9c09e8af2a5000d23d9ff15d45ac2.png";